import React from 'react';
import { MessageContainer } from './styles';
import moment from 'moment-timezone';
import { TIME_ZONE } from 'constants/constant';

const Message = ({createAt, content, staff}) => {

  return (
    <MessageContainer staff={staff}>
      <div className='createAt'>
        {moment(createAt).tz(TIME_ZONE).format('MMM Do YYYY h:mm A')}
      </div>
      <div className='content'>
        {content}
      </div>
    </MessageContainer>
  )
}

export default Message;
